import { Box, Text } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';
import { usePredefinedScreeners } from '../hooks/usePredefinedScreeners';
import { TableRowScreenerPredefined } from './TableRowScreenerPredefined';
import { ButtonNewScreener } from './ButtonNewScreener';
import { Table } from './Table';

export const ScreenersEmpty = () => {
  const { data } = usePredefinedScreeners();
  const { Track } = useTracking({
    type: 'track',
    subject: 'myScreenersIdeasModule',
  });

  return (
    <Track>
      <Table>
        <Table.HeadFake />
        <Table.Head>
          <Box paddingBottom="x1">
            <Box>
              <Box paddingY="x3">
                <Text typography="tiny" color="textSubtle" textAlign="center">
                  No saved screeners
                </Text>
              </Box>
              <ButtonNewScreener />
            </Box>
          </Box>
        </Table.Head>
        <Table.Body>
          <tr>
            <th colSpan={2}>
              <Text typography="tinyStrong" color="textSofter">
                You might like these screener ideas
              </Text>
            </th>
          </tr>
          {data.companyPredefinedScreeners.map((screener) => (
            <TableRowScreenerPredefined key={screener.id} {...screener} />
          ))}
        </Table.Body>
      </Table>
    </Track>
  );
};
